/**
 * This is the VUEX loader for our apps, to support vuex in nuxt 3
 * Note: It has to be here and load the stores dynamically because the stores need to exist for the authentication module to work etc
 * It uses dynamic imports because it needs to load the index.js in the /stores folder of w/e app is being run/built
 * The appName is the folder of the running app, i.e. "wineaccess" for /client/wineaccess or "williamssonoma" for /client/williamssonoma
 */
export default defineNuxtPlugin({
  name: 'vuexLoader',
  dependsOn: ['axiosPlugin'],
  async setup(nuxtApp) {
    const appName = nuxtApp.$config.public.appName
    let storeInstance: any | undefined | null = null
    try {
      // Dynamically import the store creation function
      const { default: createStore } = await import(
        `#root/client/${appName}/store/index.js`
      )
      // Check if the createStore function is valid
      if (!createStore || typeof createStore !== 'function') {
        console.error(
          'Store creation function is invalid or not found, please check the app has a store/index.js file.  If no longer needed refactor this plugin.',
        )
        return
      }

      storeInstance = createStore()
      storeInstance.$axios = nuxtApp.$axios
      storeInstance.$auth = nuxtApp.$auth

      nuxtApp.vueApp.use(storeInstance)
      nuxtApp.provide('store', storeInstance)
    } catch (error) {
      console.error('Failed to dynamically load vuex store:', error)
    }
  },
})
